<div class="container">

	<div class="portalCard">

		<div class="rowScreenColPhone">

			<div class="aTitle">
				<mat-icon>event</mat-icon>
				<span>{{ isInternalCalendar ? 'Interne Termine' : 'Veranstaltungen' }}</span>
			</div>

			<div style="display: flex; flex-flow: row wrap; gap: 1em">

				<button
					mat-raised-button
					(click)="toggleMode()"
				>

					@if( !bListMode ) {

						<div class="iconAndTxt">
							<span class="material-icons">list</span>
							<span>Liste</span>
						</div>

					}
					@else {

						<div class="iconAndTxt">
							<span class="material-icons">event</span>
							<span>Kalender</span>
						</div>

					}

				</button>

				@if( bAdmin ) {

					<button
						mat-raised-button
						[routerLink]="[ 'bearbeiten' ]"
					>
						<div class="iconAndTxt">
							<span class="material-icons">add</span>
							<span>Erstellung</span>
						</div>
					</button>

					<button
						mat-raised-button
						[routerLink]="[ '../Formulare' ]"
					>
						<div class="iconAndTxt">
							<span class="material-icons">dynamic_form</span>
							<span>Formulare</span>
						</div>
					</button>

				}

			</div>

		</div>

		@if( !bListMode ) {
			<app-event-grid [isInternalCalendar]="isInternalCalendar" />
		}
		@else {
			<app-event-list [isInternalCalendar]="isInternalCalendar" />
		}

	</div>

</div>

